import { render, staticRenderFns } from "./PriTama06_Core.vue?vue&type=template&id=1f4d8ef2&scoped=true&"
import script from "./PriTama06_Core.vue?vue&type=script&lang=js&"
export * from "./PriTama06_Core.vue?vue&type=script&lang=js&"
import style0 from "./PriTama06_Core.vue?vue&type=style&index=0&id=1f4d8ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d8ef2",
  null
  
)

export default component.exports